import { render, staticRenderFns } from "./autoMatchOrder.vue?vue&type=template&id=bd50d962&scoped=true"
import script from "./autoMatchOrder.vue?vue&type=script&lang=js"
export * from "./autoMatchOrder.vue?vue&type=script&lang=js"
import style0 from "./autoMatchOrder.vue?vue&type=style&index=0&id=bd50d962&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd50d962",
  null
  
)

export default component.exports